module.exports = __webpack_public_path__ + "static/bootstrap-card-deck-84554e64580a0e8d822e96a31dd0697f.png";